module.exports = __webpack_public_path__ + "static/media/product_3@3x.d811ea7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/early_access/product_3/product_3@3x.png
// module id = 69
// module chunks = 0